// Single shared latch for the two auth-error flows that pop a user-visible
// modal: handleAuthError in shared/lib/http/axios.ts (50001 axios path,
// cross-tab, logout, unsubscribe) and promptReLogin in
// platform/notifications/ws-bridge.ts (50001 WS push).
//
// Without a shared latch the two channels can fire concurrently — backend
// pushes 50001 over WS while a slow in-flight axios call gets 50001 back —
// and the user sees two stacked modals. Lives outside both modules so
// neither needs to know about the other's internals (the axios → ws-bridge
// edge would be a circular import otherwise).

let active = false;
let committed = false;

export function isSignOutActive(): boolean {
  return active;
}

export function beginSignOut(): boolean {
  if (active) return false;
  active = true;
  committed = false;
  return true;
}

export function commitSignOut(): void {
  committed = true;
}

export function isSignOutCommitted(): boolean {
  return committed;
}

export function endSignOut(): void {
  active = false;
  committed = false;
}
